import React, { PropsWithChildren } from 'react';
import { ModuleTopBar, Box, Flex, Grid } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import FlowProductsBottomBar from '@flows/src/components/flow-products/FlowProductsBottomBar';
import FlowProductsAnvaSidebar from '@flows/src/components/flow-products/FlowProductsAnvaSidebar';
import { FLOWS_PRODUCTS_PATH } from '@flows/src/FlowsProductsRouter';
import { useHistory, useParams } from 'react-router';
import useQueryParams from '@common/src/hooks/useQueryParams';
import { useFlowsSession } from '@flows/src/api/getFlowsSessionById';
import useStartAnvaFlow from '@sales-conversation/src/hooks/anva/useStartAnvaFlow';

const FlowProductsLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();
  const queryParams = useQueryParams();
  const sessionId = queryParams.get('session_id') || undefined;
  const { data: session } = useFlowsSession(sessionId);
  const startFlow = useStartAnvaFlow();
  const history = useHistory();
  const { flowId } = useParams<{ flowId: string }>();

  const getBackText = () => {
    if (window.location.pathname.includes('basket')) {
      return t('BACK-TO-OVERVIEW');
    }
    return t('Back to questions');
  };
  const handlePrevious = () => {
    const searchParams = window.location.search;
    if (window.location.pathname.includes('basket')) {
      return history.push({
        pathname: `${FLOWS_PRODUCTS_PATH}/${flowId}/overview`,
        search: searchParams,
      });
    }
    if (flowId && sessionId) {
      history.push(`/flows/${flowId}/questions/${sessionId}`);
      startFlow({
        flowId: flowId,
        uuid: sessionId,
        partyId: session?.prospect?.id,
        anva_products: session?.anva_products || [],
      });
    }
  };

  const getTopBarText = (): string => {
    if (window.location.pathname.includes('selection-overview')) {
      return t('FLOWS_PRODUCTS_SELECTION-OVERVIEW_TOP-BAR_TITLE');
    }
    return t('CONVERSATIONS_REPORT-CREATION_PRODUCT-SELECTION');
  };

  return (
    <Grid
      templateColumns={{ base: 'auto 1fr' }}
      w="100%"
      h="100%"
      position="relative"
    >
      <FlowProductsAnvaSidebar />
      <Grid
        templateRows="auto 1fr auto"
        position="relative"
        overflow-y="auto"
        flexGrow="1"
      >
        <Box position="sticky" top="0" bg="white" zIndex="1">
          <ModuleTopBar
            // backRef={getPreviousUrl()}
            title={getTopBarText()}
            backText={getBackText()}
          />
        </Box>
        <Flex
          flexDirection="column"
          w="100%"
          align="center"
          flexGrow="1"
          bg="gray.ultraLight"
        >
          {children}
        </Flex>
        <FlowProductsBottomBar
          handlePrevious={handlePrevious}
          backText={getBackText()}
        />
      </Grid>
    </Grid>
  );
};

export default FlowProductsLayout;
